import {useCallback, useEffect, useState} from "react";
import {service} from "infrastructure/index";
import {ApiSettings, AppRoutes} from "application/index";
import {useDispatch, useSelector} from "react-redux";
import {select} from "application/store";
import {useHistory} from "react-router-dom";
import {debounce as debounceFunction} from "throttle-debounce";

export const useMyDocuments = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const state = useSelector(
    select((models) => ({
      userInfo: models.auth.user,
      documents: models.myDocuments.documents,
      isLoading: models.myDocuments.isLoading,
    }))
  );

  const [filterBy, onChangeInnerFilterBy] = useState();

  useEffect(() => {
    if (!state?.userInfo?.email) return;

    const evtStream = service.createEventStreamListener({
      eventPath: ApiSettings.reportEventStream(state.userInfo.email),
      dispatch: console.log
    });

    return () => {
      evtStream.close();
    }
  }, [state?.userInfo?.email]);


  useEffect(() => {
    dispatch.myDocuments.loadDocumentsAction();
  }, []);


  const goToNewReport = useCallback(() => {
    history.push(AppRoutes.newReport);
  }, []);

  const goToDocumentDetail = useCallback((id) => {
    history.push(AppRoutes.documentDetail.replace(':id', id));
  }, []);

  const onChangeFilterBy = useCallback(
    debounceFunction(250, (value) => {
      dispatch.myDocuments.setSearchTermAction(value);
    }),
    [],
  );

  return {
    ...state,
    filterBy,
    onChangeFilterBy,
    onChangeInnerFilterBy,
    goToNewReport,
    goToDocumentDetail
  }
}
